import { MyJoi } from "@sr-partner-portal/common";

const jobExperienceValidationSchema = MyJoi.object({
    company: MyJoi.myString().min(3).max(100).required(),
    position: MyJoi.myString().min(2).max(100).required(),
    description: MyJoi.string().min(10).max(500),
    startDate: MyJoi.date().required(),
    endDate: MyJoi.date().when("isCurrent", {
        is: true,
        // biome-ignore lint/suspicious/noThenProperty: <explanation>
        then: MyJoi.date().optional().allow(null),
        otherwise: MyJoi.date().min(MyJoi.ref("startDate")).required(),
    }),
    isCurrent: MyJoi.boolean().required(),
}).required();

export { jobExperienceValidationSchema };
